import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _WellClusterLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", d: "m19.282 10.155-.923.896h-4.655l-.856-.798v-4.66l.855-.885zM19.282 13.845l-.923-.896h-4.655l-.856.798v4.66l.855.885zM4.718 10.155l.923.896h4.655l.856-.798v-4.66l-.855-.885zM4.718 13.845l.923-.896h4.655l.856.798v4.66l-.855.885z" }) }) });
}
const WellClusterLightCustom = forwardRef(_WellClusterLightCustom);
export { WellClusterLightCustom };
